import axios, { AxiosInstance } from "axios";

class NodeProvider {
    public axiosInstance: AxiosInstance;

    public url = 'http://localhost:3000/api'; // Assuming local dev for now, or use env var

    constructor() {
        this.axiosInstance = axios.create({
            baseURL: this.url,
            headers: {
                'Content-Type': 'application/json'
            }
        });

        this.axiosInstance.interceptors.response.use(
            response => response,
            async (error) => {
                if (error.response && error.response.status === 401) {
                    const { toast } = await import('react-toastify');

                    toast.error('Sessão expirada. Por favor, faça login novamente.');

                    localStorage.removeItem('ethosxAnalista:token');
                    sessionStorage.removeItem('analystName');
                    sessionStorage.removeItem('token');

                    if ('caches' in window) {
                        try {
                            const names = await caches.keys();
                            names.forEach(name => caches.delete(name));
                        } catch (e) {
                            console.error('Error clearing cache', e);
                        }
                    }

                    setTimeout(() => {
                        window.location.href = '/login';
                    }, 1500);
                }
                return Promise.reject(error);
            }
        );
    }
}

export default new NodeProvider().axiosInstance;
